<div #cashoutMain class="cashout-main">
  <div class="cashout-slip-item">
    <div class="slip-top-area" (click)="openSlip.emit(slipID)">
      <div class="slip-top-left-area">
        <div class="slip-combine">
          <p>{{ slipType }}</p>
        </div>
        <div class="slip-live" *ngIf="isLive">
          <p>{{ 'LIVE' | t }}</p>
        </div>
      </div>
      <div class="slip-top-right-area">
        <div>
          <div class="slip-top-pw">
            <p>
              {{ 'CASHOUT.PSBL_WIN' | t }}: <span class="slip-top-right-m">{{ possibleWin }}</span>
            </p>
          </div>
          <div class="slip-top-skate">
            <p>
              {{ 'CASHOUT.STAKE' | t }}: <span class="slip-top-right-m">{{ stake }}</span>
            </p>
          </div>
        </div>
        <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon cashout-collapse ' + (slipIsOpen === slipID ? ' up' : 'down')"></image-loader-utils>
      </div>
    </div>
    <ng-container *ngIf="slipIsOpen === slipID">
      <ng-container *ngIf="matchData && matchData.length > 0">
        <div class="slip-center-area">
          <div
            class="match-item-container"
            *ngFor="let matchItem of matchData; trackBy: trackBySlipId"
            (click)="goEventDetail(matchItem.matchId, matchItem.liveTime && matchItem.liveTime !== '', matchItem.matchScoreResult && matchItem.matchScoreResult !== '')">
            <div class="match-top" *ngFor="let oddItem of matchItem._groupingCashoutItem">
              <div class="odd-name">
                <div *ngIf="matchItem.Banko" class="match-top-banko"><p>B</p></div>
                <p class="odd-name-p">{{ oddItem.oddTypeNameTranslated }} {{ oddItem.specialBetValue }} ({{ oddItem.outCome }})</p>
              </div>
              <div #matchOdd class="match-odd">
                <p *ngIf="oddItem.isActive === false && oddItem.isWon === false && oddItem.isLost === false">
                  <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
                </p>
                <p>{{ oddItem.oddValue.toFixed(2) }}</p>
                <p *ngIf="oddItem.isWon === true" class="math-won-status">{{ 'CASHOUT.WON' | t }}</p>
                <p *ngIf="oddItem.isLost === true" class="math-lost-status">{{ 'CASHOUT.LOST' | t }}</p>
              </div>
            </div>
            <div class="match-bottom">
              <div class="match-description">
                <div #matchDescriptionColumnOne class="match-description-column-one">
                  <p>{{ matchItem.matchName }}</p>
                </div>
                <div *ngIf="matchItem.gameScore1H" #matchDescriptionColumnThree class="match-description-column-three">
                  <p>{{ 'OddsFirstHalf' | t }}</p>
                </div>
                <div #matchDescriptionColumnTwo class="match-description-column-two">
                  <p>Score {{ matchItem.matchScoreWhenBet }} ({{ matchItem.matchTimeWhenBet.trim() !== '' ? matchItem.matchTimeWhenBet : ('before_match' | t) }} )</p>
                </div>
              </div>
              <div *ngIf="matchItem.liveTime && matchItem.liveTime !== ''" class="match-score-and-minute">
                <p>{{ matchItem.liveScore }}</p>
                <p *ngIf="matchItem.gameScore1H">{{ matchItem.gameScore1H }}</p>

                <p class="match-minute">{{ matchItem.liveTime }}</p>
              </div>
              <div *ngIf="matchItem.timeStatusCode && matchItem.timeStatusCode === 3" class="match-score-and-minute">
                <p>{{ matchItem.timeStatusCodeContent }}</p>
              </div>

              <div *ngIf="matchItem.matchScoreResult && matchItem.matchScoreResult !== ''" class="match-score-and-minute">
                <p>{{ matchItem.matchScoreResult }}</p>
                <p class="match-minute blackColor">{{ 'CASHOUT.ENDED' | t }}</p>
              </div>

              <div
                *ngIf="!((matchItem.liveTime && matchItem.liveTime !== '') || matchItem.timeStatusCode < 5) && !(matchItem.matchScoreResult && matchItem.matchScoreResult !== '')"
                class="match-score-and-minute pre">
                <p>{{ matchItem.matchDate | dateFormat : 'dd.MM.yy' }}</p>
                <p>{{ matchItem.matchDate | dateFormat : 'HH:mm' }}</p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <div class="slip-bottom-area">
      <div class="cashout-pay-confirm" *ngIf="CASHOUT_STATE === 'confirm'">
        <div class="confirmation-text">
          {{ 'CASHOUT.ARE_YOU_CASHOUT' | t }}
        </div>
        <div class="buttons-wrapper">
          <div class="cashout-confirmation-button confirm">
            <p (click)="handleCashoutConfirm()">{{ 'CASHOUT.CONFIRM' | t }}</p>
          </div>
          <div class="cashout-confirmation-button cancel" (click)="handleCashoutPay('cancel')">
            <p>{{ 'CASHOUT.CANCEL' | t }}</p>
          </div>
        </div>
      </div>

      <div class="cashout-button {{ CASHOUT_STATE }}" (click)="handleCashoutPay('confirm')">
        <div class="c-text">
          <p class="c-subtitle">
            {{ 'NEW_CASHOUT.STATE.' + CASHOUT_STATE | t }}
          </p>
          <p class="c-value">{{ getCashoutValue() }}€</p>
        </div>
        <apx-chart
          [series]="
            this._DataHelper.cashoutTimeLineData[slipID] &&
            this._DataHelper.cashoutTimeLineData[slipID].length > 0 &&
            this._DataHelper.cashoutTimeLineData[slipID][0].data.length > 3
              ? this._DataHelper.cashoutTimeLineData[slipID]
              : this.chartOptions.series
          "
          [chart]="chartOptions.chart"
          [xaxis]="chartOptions.xaxis"
          [stroke]="chartOptions.stroke"
          [dataLabels]="chartOptions.dataLabels"
          [yaxis]="chartOptions.yaxis"
          [labels]="chartOptions.labels"
          [legend]="chartOptions.legend"
          [title]="chartOptions.title"
          [subtitle]="chartOptions.subtitle"
          [tooltip]="chartOptions.tooltip"
          [grid]="chartOptions.grid"
          [colors]="chartOptions.colors"></apx-chart>
      </div>
    </div>
  </div>
</div>
<p class="cashout-slipID" (click)="goSlipDetail()">#{{ slipID }}</p>
